import React from 'react'
import { TipoCliente } from '@/types'

type Props = {
  tipo: string
  estado: string
  onChange: (v: { tipo?: string; estado?: string }) => void
  onApply: () => void
}

const ClientFilters: React.FC<Props> = ({ tipo, estado, onChange, onApply }) => {
  return (
    <div className="flex gap-2">
      <select className="border rounded px-2 py-1" value={tipo} onChange={(e) => onChange({ tipo: e.target.value })}>
        <option value="">Todos los tipos</option>
        <option value={TipoCliente.PROPIETARIO}>Propietario</option>
        <option value={TipoCliente.INQUILINO}>Inquilino</option>
        <option value={TipoCliente.AMBOS}>Ambos</option>
      </select>
      <select className="border rounded px-2 py-1" value={estado} onChange={(e) => onChange({ estado: e.target.value })}>
        <option value="">Todos</option>
        <option value="activo">Activo</option>
        <option value="inactivo">Inactivo</option>
      </select>
      <button className="px-3 py-1 rounded bg-blue-600 text-white" onClick={onApply}>Aplicar</button>
    </div>
  )
}

export default ClientFilters


